import fuzzyTextFilterFn from "./fuzzyTextFilter";

const filterTypes = {
	text: fuzzyTextFilterFn,
};

export default filterTypes;
